import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=7f67db43&lang=pug&"
import script from "./Media.vue?vue&type=script&lang=js&"
export * from "./Media.vue?vue&type=script&lang=js&"
import style0 from "./Media.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f67db43')) {
      api.createRecord('7f67db43', component.options)
    } else {
      api.reload('7f67db43', component.options)
    }
    module.hot.accept("./Media.vue?vue&type=template&id=7f67db43&lang=pug&", function () {
      api.rerender('7f67db43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/edit/Media.vue"
export default component.exports